import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Circle } from 'react-native-svg';

const DotIcon = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg width={props.width ?? 29} height={props.height ?? 29} viewBox="0 0 29 29" fill="none">
          <Circle
            cx="14.7461"
            cy="14.3867"
            r="13.6758"
            fill={'#FFF5DD'}
            // stroke="#FDDB96"

            stroke={props.color ?? '#FDDB96'}
          />
          <Circle
            cx="14.7427"
            cy="14.3872"
            r="5.51612"
            fill={props.color ?? '#FDDB96'}
            stroke={props.color ?? '#FDDB96'}
          />
        </Svg>
      </View>
    );
  },
);

export { DotIcon };
